module.exports = __webpack_public_path__ + "static/heroku-books-dashboard-89c9b7e60114dfb463adf29255edbc71.png";